<template>
  <button class="LmButton" :class="buttonClasses" @click.prevent="onClick">
    <lm-loading v-if="loading" :size="resolveSize" :color="loadingColor" />
    <span v-show="!loading">
      <slot />
    </span>
  </button>
</template>

<script>
import LmLoading from '@/components/ui/LmLoading'

export default {
  name: 'LmButton',
  components: {LmLoading},
  props: {
    type: {
      type: String, // default | primary | warning
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClasses() {
      const c = 'Type-' + this.type
      const d = this.disabled ? 'is-disabled' : ''
      const l = this.loading ? 'is-loading ' : ''
      const m = this.mini ? 'is-mini ' : ''
      return `${c} ${d} ${l} ${m}`
    },
    loadingColor() {
      return this.type === 'default' ? '#1a1a1a' : '#ededed'
    },
    resolveSize() {
      return this.mini ? 20 : 24
    }
  },
  methods: {
    onClick(e) {
      if (!this.disabled && !this.loading) this.$emit('click', e)
    }
  }
}
</script>

<style>
.LmButton {
  /* reset */
  outline: 0;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 80px;
  height: 40px;
  padding: 0 15px;
  font-family: theme('fontFamily.mono');
  font-size: 14px;
  text-transform: uppercase;
  text-align: center;
  background-color: #eeeeee;
  &.is-mini {
    min-width: 62px;
    height: 32px;
    font-size: 12px;
  }
  &.Type-default:hover {
    background-color: #d2d2d2;
  }
  &.is-disabled,
  &.is-loading {
    color: rgba(0, 0, 0, 0.25);
    cursor: auto;
    &:hover {
      background-color: #eeeeee;
    }
  }
  &.Type-primary {
    background-color: #060606;
    color: white;
    &:hover {
      background-color: #383838;
    }
    &.is-disabled,
    &.is-loading {
      color: rgba(255, 255, 255, 0.25);
      &:hover {
        background-color: #060606;
      }
    }
  }
  &.Type-warning {
    background-color: #ff0d00;
    color: white;
    &:hover {
      background-color: #ff4b41;
    }
    &.is-disabled,
    &.is-loading {
      color: rgba(255, 255, 255, 0.25);
      &:hover {
        background-color: #ff0d00;
      }
    }
  }
}
.js-focus-visible .LmButton:focus:not(.focus-visible) {
  outline: none;
}
</style>
